import { BorderType, DateWithTimezones, SCode } from '../../../../common';
import { LinkInfoType, MilestoneType } from '../../../models/shipment-status-chain.model';

export class ShipmentLoadStatusChainModel {
  active: boolean;
  actualDate: DateWithTimezones;
  address: string;
  code: SCode;
  description: string;
  descriptionActive: boolean;
  estimatedDate: DateWithTimezones;
  index: number;
  secondarySource: boolean;
  linkInfoType: LinkInfoType;
  linkType: BorderType;
  major: boolean;
  passed: boolean;
  title: string;
  titleAddress: string;
  type: MilestoneType;
  transportName: string;
}
